module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-ani"
  }, [_c('div', {
    staticClass: "kj-ani-cont"
  }, [_c('img', {
    staticClass: "kj-ani-img",
    attrs: {
      "src": require("./knife.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kj-ani-text"
  }, [_vm._v("正在砍价")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4533e4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/bargainAnimation/index.vue
// module id = 284
// module chunks = 0